"use client";

import { useCallback, useState } from "react";
import type { ToastData, ToastType } from "../components/Toast";

export function useToast() {
  const [toasts, setToasts] = useState<ToastData[]>([]);

  const closeToast = useCallback((id: number) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const showToast = useCallback(
    (type: ToastType, title: string, description?: string) => {
      const id = Date.now() + Math.random();
      setToasts((prev) => [...prev, { id, type, title, description }]);
    },
    [],
  );

  return { toasts, showToast, closeToast };
}
